//********************************************************************************
//* This file defines the Application Insights configuration for the application.
//* and global object to use when tracking events.
//********************************************************************************
import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import { ReactPlugin } from "@microsoft/applicationinsights-react-js";
import { createBrowserHistory } from "history";
import { getAppInsightInfo } from './authConfig';

const browserHistory = createBrowserHistory({ basename: "" });
const reactPlugin = new ReactPlugin();
let appInsights: ApplicationInsights;
getAppInsightInfo().then(appInsightInfo => {
  appInsights = new ApplicationInsights({
    config: {
      connectionString: appInsightInfo.CONNECTION_STRING,
      instrumentationKey: appInsightInfo.INSTRUMENTATION_KEY,
      isBeaconApiDisabled: true,
      enableAutoRouteTracking: true,
      extensions: [reactPlugin],
      extensionConfig: {
        [reactPlugin.identifier]: { history: browserHistory },
      },
      enableDebug: true,
    },
  });
  appInsights.loadAppInsights();
});
export { reactPlugin, appInsights };
